import React from "react";
import { connect } from "react-redux";
import ReportPrestaciones from "powerbi-report-component";


class PrestacionesGrafico extends React.PureComponent {
  render() {
    const reporte3 = [];
    if (this.props.companyId) {
      const config2 = {};

      config2.embedUrl = `${this.props.config.embedUrl}&pageName=ReportSectionbf1ca51c7c65b5893e5e&filter=Prestaciones/Prestaciones_RutEmpresa eq '${this.props.companyId}' and Estructura_x0020_Meses_x0020_Prestaciones/Prestaciones_Meses eq '${this.props.range} Meses'`;
      if (!(this.props.sucursalId === "")) { config2.embedUrl += ` and Prestaciones/Prestaciones_BP_Sucursal eq '${this.props.sucursalId}'`; }


      config2.extraSettings = {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        allowFullScreen: false,
      };
      const prestaciones = `prestaciones${new Date().getTime()}`;
      reporte3.push(<ReportPrestaciones
        key={prestaciones}
        embedType={this.props.config.embedType}
        tokenType={this.props.config.tokenType}
        accessToken={this.props.EmbedTokenPowerBi}
        embedUrl={config2.embedUrl}
        embedId={this.props.config.embedId}
        extraSettings={{
          filterPaneEnabled: config2.extraSettings.filterPaneEnabled,
          navContentPaneEnabled: config2.extraSettings.navContentPaneEnabled,

        }}

        permissions="All"
        style={{
          height: "300px",
          border: "0",
          padding: "0px",
          background: "#eee",
        }}
      />);
    }


    return (

      <React.Fragment >
        {reporte3}
      </React.Fragment>

    );
  }
}
const mapStateToProps = (state) => ({

  config: state.graficos.config,
  EmbedTokenPowerBi: state.graficos.EmbedTokenPowerBi,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  range: state.resumenEmpresa.range,

});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(PrestacionesGrafico);

